/*
 * Bonvelle · Rhode-laag: de vulling van een pill schuift in vanaf de kant waar de muis
 * binnenkomt (Rhode: clip-path, .25s). Zet data-rh-van="links|rechts" vlak voor de hover.
 * Zonder dit script vult hij gewoon van links.
 */
document.addEventListener(
  'pointerover',
  (e) => {
    const pil = e.target instanceof Element ? e.target.closest('.rh-pil') : null;
    if (!pil || (e.relatedTarget instanceof Node && pil.contains(e.relatedTarget))) return;
    const r = pil.getBoundingClientRect();
    pil.dataset.rhVan = e.clientX - r.left < r.width / 2 ? 'links' : 'rechts';
  },
  { passive: true }
);
